import { useRegions } from '@/components/providers/RegionsProvider';
import { pagesPath } from '@/lib/$path';

export const usePaths = () => {
  // Kept in case need a quick revert
  // const { currentChannel, currentLocale: locale } = useRegions();
  return pagesPath;
};
